import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=3806ebea&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"
import style0 from "./Infos.vue?vue&type=style&index=0&id=3806ebea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806ebea",
  null
  
)

export default component.exports